import { Component, Ref, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { BodyOverlay } from '../BodyOverlay/BodyOverlay';

@Component
export class ProductQuickAddTrigger extends ThemeComponent {
    @Ref() button!: HTMLButtonElement;
    private bodyOverlay: BodyOverlay|null = null;

    init() {
        this.listenForButtonClick();
        this.bodyOverlay = document.querySelector('.body-overlay');
    }

    private listenForButtonClick() {
        this.$listen(this.button, 'click', () => {
            if (this.bodyOverlay && window.innerWidth <= 1024) {
                this.bodyOverlay.classList.remove('hidden');
                setTimeout(() => {
                    this.bodyOverlay?.classList.add('visible');
                }, 10);
            }
            for (const other of document.querySelectorAll('product-quick-add.is-active')) {
                other.classList.remove('is-active');
            }
            const quickAdd = this.parentElement?.querySelector('.product-quick-add');
            if (quickAdd) {
                quickAdd.classList.add('is-active');
            }
            if (window.innerWidth <= 1024) {
                document.body.classList.add('no-scroll');
            }
        });
    }
}
